import { useRef, useState } from 'react'
import helpers from 'core/helpers'
import { ISelectedInfo } from '../__info/displays__info.local.methods'

export interface IDisplaysScreenShotsProps {
    open: boolean
    selectedInfo: ISelectedInfo
    onClose: () => void
}

export interface IState {
    minimized: boolean
    maxZoom: boolean
    minZoom: boolean
    isScreenshotUpdating: boolean
    image: string
    caption: string
    type: string
    rotate: number
    url?: string
    item?: {
        matadata: string
        duration?: string
        src: string
        fileType: string
        id: number
        name: string
        folderId: number
        data: string
        isDirectory: number
        type: string
        displayAs: string
        thumbnail: string
        style: object
    }
}

const STEP_ON_ROTATE = 90
const MAX_ROTATE_VALUE = 270
const defaultImageState = {
    image: '',
    caption: '',
    type: '',
    rotate: 0,
}

export const DisplaysScreenShotsMethods = (p_: IDisplaysScreenShotsProps) => {
    const [state, setState] = useState<IState>({
        ...defaultImageState,
        minimized: helpers.isMobileDevice(),
        maxZoom: false,
        minZoom: false,
        isScreenshotUpdating: false,
    })
    const imageViewRef = useRef<any>(null)

    const zoomOut = () => {
        if (imageViewRef && imageViewRef.current && imageViewRef.current.zoomOut) {
            imageViewRef.current.zoomOut()
        }
    }

    const zoomIn = () => {
        if (imageViewRef && imageViewRef.current && imageViewRef.current.zoomIn) {
            imageViewRef.current.zoomIn()
        }
    }

    const onRotate = () => {
        let rotate = state.rotate

        if (rotate < MAX_ROTATE_VALUE) {
            rotate += STEP_ON_ROTATE
        } else {
            rotate = 0
        }

        setState((prevState) => {
            return {
                ...prevState,
                rotate,
            }
        })
    }

    return {
        state,
        setState,
        onRotate,
        zoomIn,
        zoomOut,
        imageViewRef,
    }
}
